export default __webpack_public_path__ + "static/media/MyCast&CrewLogo.32f27e08.svg";